import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './Components/auth/service/auth.guard';
import { NotFoundComponent } from './core/not-found/not-found.component';
import {UiKitComponent} from './ui-kit/ui-kit.component';


const routes: Routes = [
  { path: '', redirectTo: 'landings', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () => import('./Components/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'landings',
    loadChildren: () => import('./Components/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./Components/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: ':slug',
    loadChildren: () => import('./Components/landing/landing-view.module').then(m => m.LandingViewModule)
  },
  {
    path: 'ui-kit',
    component: UiKitComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
